import { ChangeDetectorRef, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { MenuOption, MenuService } from "../app-layout/main-layout/menu-option";
import { concat, filter } from "rxjs";
import { AuthService } from '../../../services/auth.service';
import AOS from 'aos';

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.scss'],
})
export class LandingPageComponent implements OnInit, OnDestroy {
  menuServices: MenuService = inject(MenuService);
  menuOptions: MenuOption[] = [];
  protected readonly concat = concat;
  authService = inject(AuthService);

  bgSlides: string[] = [
    'assets/images/slide1.jpeg',
    'assets/images/slide2.jpg',
    'assets/images/slide3.jpg',
  ];

  isMenuOpen = false;
  currentIndex = 0;
  intervalId: any;

  constructor(private router: Router, private cdr: ChangeDetectorRef) {
    // Reload menu whenever navigating back to /landing
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if (event.urlAfterRedirects === '/landing') {
          this.reloadMenuOptions();
        }
      });
  }

  async ngOnInit() {
    await this.reloadMenuOptions();
    this.startAutoSlide();
  }

  ngOnDestroy() {
    clearInterval(this.intervalId);
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  async reloadMenuOptions() {
    this.menuOptions = await this.menuServices.getMenuOptions();
    this.cdr.detectChanges(); // update DOM first
    AOS.refreshHard();        // re-run animations
  }

  startAutoSlide() {
    this.intervalId = setInterval(() => {
      this.nextSlide();
    }, 5000); // 5 seconds
  }

  prevSlide() {
    this.currentIndex =
      (this.currentIndex - 1 + this.bgSlides.length) % this.bgSlides.length;
  }

  nextSlide() {
    this.currentIndex = (this.currentIndex + 1) % this.bgSlides.length;
  }

  navigateBack() {
    this.authService.logout();
    // ✅ Use absolute path, not relative
    this.router.navigate(['/landing']);
  }

  navigateForward() {
    this.router.navigate(['/manage/warehouse-management/dashboard']);
  }
}
